import { gql } from '@apollo/client';

export const REMOVE_REVIEW = gql`
  mutation ($id: String!) {
    removeReview(id: $id)
  }
`;
